//
//The module wraps up the basic CRUD operations to interact with the server
//The Url parameter should includes all the parameters required to retrieve data from the server
//and they can be added to relevant functions in the service layer
//
import Axios from 'axios'
import store from '../store/index.js'
//
//Should be called when there is a token and need to access to authorized resource
//
function authenticatedAxios() {
    //Always get token from store after logged in
    return Axios.create({
        headers: {
            'Authorization': `Bearer ${store.state.login.token}`
        }
    });     
}
//
//Get data from server by GET method without authorization and parameters
//
async function getData(url) {
    await Axios.get(url)
                .then((response) => {
                    return response.data
                })
                .catch((error) => {
                    if (error.response) {

                    }
                    else if (error.request) {

                    }
                    else {

                    }
                });
}

//
//Get data from server by GET method with authorization token
//
async function getDataWithToken(url) {
    let response = await authenticatedAxios().get(url);
    return response.data;           
}

//
//Post data to server by POST method with authorization token
//
async function postData(url, data) {
    await authenticatedAxios().post(url, data)
                              .then(res => {
                                  return res
                              })
                              .catch(err => {
                                  if (err.response) {
                                      return err.response;
                                  }
                                  else {
                                      
                                  }
                              });
} 

//
//Put data to server by PUT method with authorization token
//
async function putData(url, data) {
    return await authenticatedAxios().put(url, data);
} 

//
//Delete data to server by DELETE method with authorization token
//
async function deleteData(url) {
    return await authenticatedAxios().delete(url);
}

async function postFile(url, formData) {
    return Axios.create({
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${store.state.login.token}`
        }
    }).post(url,
        formData
    ).then(function(response) {
        console.log(response);
    }).catch(function(response) {
        console.log(response)
    }); 
   
}

export default {
    name: 'common',
    getData,
    getDataWithToken,
    postData,
    putData,
    deleteData,
    postFile
}